import { Fragment as _Fragment, createVNode as _createVNode } from "vue";
import { computed, defineComponent } from "vue";
import { extend, addUnit, numericProp, getSizeStyle, makeStringProp, createNamespace } from "../utils/index.mjs";
const [name, bem] = createNamespace("loading");
const SpinIcon = Array(12).fill(null).map((_, index) => _createVNode("i", {
  "class": bem("line", String(index + 1))
}, null));
const CircularIcon = _createVNode("svg", {
  "class": bem("circular"),
  "viewBox": "25 25 50 50"
}, [_createVNode("circle", {
  "cx": "50",
  "cy": "50",
  "r": "20",
  "fill": "none"
}, null)]);
const JoyIcon = _createVNode(_Fragment, null, [_createVNode("div", {
  "class": bem("joy-coin")
}, [_createVNode("svg", {
  "viewBox": "0 0 300 300",
  "width": "100%",
  "height": "100%"
}, [_createVNode("path", {
  "d": "M150.003 0c82.8 0 150 67.2 150 150 0 32.8-10.5 64.1-29.8 89.8-28.2 37.6-72.3 60.2-120.2 60.2-50.3 0-96.4-25-124.2-65.8-16.7-24.7-25.8-53.8-25.8-84.2 0-82.8 67.2-150 150-150zm-7.6 100.2-42.3 42.3c-3.3 3.3-3.3 8.7 0 12.1l42.4 42.4c3.3 3.3 8.8 3.3 12.1 0l42.3-42.3c3.3-3.3 3.3-8.7 0-12.1l-42.4-42.4c-3.3-3.3-8.8-3.3-12.1 0z",
  "fill": "#FFF"
}, null)])]), _createVNode("div", {
  "class": bem("joy-body")
}, [_createVNode("svg", {
  "viewBox": "0 0 931 480",
  "width": "100%",
  "height": "100%"
}, [_createVNode("path", {
  "d": "M919.003 211.5c-14.3-13.6-61.4-72.2-92.2-141.5-26.9-60.7-65.8-54.6-82.9-42.2-8.3 6-36.4 32.2-36.4 32.2v.1c-42.1-27.2-121.9-60-243.4-60-120.9 0-200.4 32.5-242.8 59.6v-.1s-26.9-25.8-35.2-31.8c-17.1-12.3-56-18.4-82.9 42.2-30.7 69.3-77.9 127.9-92.2 141.5-14.3 13.6-23.6 55.1 31.1 80.3 47.7 22 111 1.7 135.5-23.3v-.1c36.9 110.8 151.6 191.6 287.4 191.6 135.8 0 250.5-80.8 287.4-191.6v.1c22.8 23.2 87.8 45.2 135.5 23.2 54.7-25.2 45.4-66.6 31.1-80.2z",
  "fill": "#FFF"
}, null)]), _createVNode("div", {
  "class": bem("joy-body-inner")
}, [_createVNode("div", {
  "class": bem("joy-eye", ["l"])
}, null), _createVNode("div", {
  "class": bem("joy-eye", ["r"])
}, null), _createVNode("div", {
  "class": bem("joy-nose")
}, null), _createVNode("div", {
  "class": bem("joy-mouth")
}, [_createVNode("svg", {
  "viewBox": "0 0 339.519 100",
  "width": "100%",
  "height": "100%"
}, [_createVNode("path", {
  "d": "M167.945 94.27c-29.2 0-56.5-4.4-81.3-13-25.1-8.7-42.2-19.9-52.1-27.8-24.2-19.1-32.7-38.8-34.1-42.6-1.2-2.9.1-6.2 3-7.5 3-1.4 6.5-.1 7.9 2.9 0 0 .1.2.2.5 3.5 9 13.6 24.2 30.4 37.6 9.2 7.3 25.1 17.7 48.6 25.8 24.3 8.4 51.1 12.5 79.8 12.3 28.8-.3 55.7-4.9 79.9-13.8 23.4-8.6 39.2-19.4 48.3-26.8 22-18.1 28.7-35.9 29.4-37.8.1-.2.1-.3.1-.4 1.2-3 4.7-4.5 7.8-3.2 3 1.2 4.4 4.5 3.3 7.4-1.4 3.8-9.1 23.3-33 43-9.8 8.1-26.8 19.6-51.8 28.8-25.5 9.4-53.7 14.3-84 14.5-.7.1-1.5.1-2.4.1z",
  "fill": "#525252",
  "fill-rule": "evenodd"
}, null)])])])])]);
const joyFragment = (opacity) => _createVNode("path", {
  "fill": "currentColor",
  "fill-opacity": opacity,
  "d": "m11.54-10.328.077-.063c.936-.758 1.726-1.328 2.373-1.71 1.306-.772 2.468-.06 3.037.897l6.05 11.082c.709 1.25 1.003 2.172.881 2.766-.182.891-1.14 3.006-3.879 3.006-1.63 0-3.422-.798-5.375-2.394-.924 2.54-2.462 4.875-4.287 6.241l-.773.579c-1.86 1.374-5.073 3.483-9.648 3.483-5.289 0-8.039-2.113-10.3-4.062-2.144-1.849-3.586-4.023-4.427-6.226-1.946 1.586-3.732 2.379-5.356 2.379-2.739 0-3.697-2.115-3.879-3.006-.114-.554.135-1.394.744-2.52l6.121-11.212c.542-1.013 1.745-1.816 3.103-1.013.686.405 1.534 1.022 2.545 1.851 3.492-2.685 8.333-3.283 11.4-3.308l.206-.001c3.128 0 7.893.294 11.387 3.231z",
  "transform": "translate(48.005 49.5) scale(1.31532)"
}, null);
const TJoyIcon = _createVNode("svg", {
  "width": "100%",
  "height": "100%",
  "viewBox": "0 0 96 96",
  "content-visibility": "visible"
}, [_createVNode("path", {
  "stroke": "currentColor",
  "stroke-opacity": ".06",
  "fill": "none",
  "stroke-width": "7",
  "d": "M48 4c24.284 0 44 19.716 44 44S72.284 92 48 92 4 72.284 4 48 23.716 4 48 4z"
}, null), joyFragment(0.12), _createVNode("g", {
  "class": bem("tjoy-arc")
}, [_createVNode("path", {
  "class": bem("tjoy-arc-blue"),
  "d": "M92 48a44 44 0 0 0-88 0",
  "stroke-linecap": "round",
  "stroke-dasharray": "30 1000",
  "stroke": "#586DF9",
  "fill": "none",
  "stroke-width": "7"
}, null), _createVNode("path", {
  "class": bem("tjoy-arc-yellow"),
  "d": "M92 48a44 44 0 0 0-88 0",
  "stroke-linecap": "round",
  "stroke-dasharray": "30 1000",
  "stroke": "#F59B55",
  "fill": "none",
  "stroke-width": "7"
}, null), _createVNode("path", {
  "class": bem("tjoy-arc-red"),
  "d": "M92 48a44 44 0 0 0-88 0",
  "stroke-linecap": "round",
  "stroke-dasharray": "30 1000",
  "stroke": "#FF4144",
  "fill": "none",
  "stroke-width": "7"
}, null)])]);
const CircularIcon1 = _createVNode("div", {
  "class": bem("circular1-icon")
}, null);
const Ljoy = _createVNode(_Fragment, null, [_createVNode("svg", {
  "width": "100%",
  "height": "100%",
  "viewBox": "0 0 96 96",
  "content-visibility": "visible"
}, [joyFragment(1)]), _createVNode("div", {
  "class": bem("ljoy-circular1")
}, null), _createVNode("div", {
  "class": bem("ljoy-circular2")
}, null)]);
const loadingProps = {
  size: numericProp,
  type: makeStringProp("circular"),
  color: String,
  vertical: Boolean,
  textSize: numericProp,
  textColor: String
};
var stdin_default = defineComponent({
  name,
  props: loadingProps,
  setup(props, {
    slots
  }) {
    const spinnerStyle = computed(() => extend({
      color: props.color
    }, getSizeStyle(props.size)));
    const renderIcon = () => {
      let clsName = "";
      let DefaultIcon;
      if (props.type === "spinner") {
        DefaultIcon = SpinIcon;
        clsName = "spinner";
      } else if (props.type === "joy") {
        DefaultIcon = JoyIcon;
        clsName = "joy";
      } else if (props.type === "tjoy") {
        DefaultIcon = TJoyIcon;
        clsName = "tjoy";
      } else if (props.type === "circular1") {
        DefaultIcon = CircularIcon1;
        clsName = "circular1";
      } else if (props.type === "ljoy") {
        DefaultIcon = Ljoy;
        clsName = "ljoy";
      } else {
        DefaultIcon = CircularIcon;
        clsName = "spinner";
      }
      return _createVNode("span", {
        "class": bem(clsName, props.type),
        "style": spinnerStyle.value
      }, [slots.icon ? slots.icon() : DefaultIcon]);
    };
    const renderText = () => {
      var _a;
      if (slots.default) {
        return _createVNode("span", {
          "class": bem("text"),
          "style": {
            fontSize: addUnit(props.textSize),
            color: (_a = props.textColor) != null ? _a : props.color
          }
        }, [slots.default()]);
      }
    };
    return () => {
      const {
        type,
        vertical
      } = props;
      return _createVNode("div", {
        "class": bem([type, {
          vertical
        }]),
        "aria-live": "polite",
        "aria-busy": true
      }, [renderIcon(), renderText()]);
    };
  }
});
export {
  stdin_default as default,
  loadingProps
};
